import * as LegacyReportStore from './report/LegacyReport'
import * as LegacyReportModels from '../models/report/LegacyReport'

import * as LegacyTaskStore from './report/LegacyTask'
import * as LegacyTaskModels from '../models/report/LegacyTask'

import * as LoadingStore from './Loading'
import * as LoadingModels from '../models/config/Loading'

import * as lisCommandStore from './liscommand/liscommand'
import * as lisCommandModels from '../models/liscommand/liscommand'

import * as EmployeeModel from '../models/config/Employee';
import * as Employee from './config/EmployeeMaster';

import * as EnvModel from '../models/common/Env'
import * as EnvStore from './common/Env'

// App State
import * as AppState from './AppState'
import * as ModelsAppState from '../models/AppState'

// The top-level state object
export interface ApplicationState {
    legacyReport: LegacyReportModels.GetLegacyReportState | undefined;
    legacyTask: LegacyTaskModels.GetLegacyTaskState | undefined;
    Loading: LoadingModels.LoadingState | undefined;
    lisCommand: lisCommandModels.TestSftpSourceState | undefined;
    employee: EmployeeModel.EmployeeState | undefined;
    Env: EnvModel.EnvState | undefined;
    appState: ModelsAppState.AppState | undefined;
}

// Whenever an action is dispatched, Redux will update each top-level application state property using
// the reducer with the matching name. It's important that the names match exactly, and that the reducer
// acts on the corresponding ApplicationState property type.
export const reducers = {
    legacyReport: LegacyReportStore.rootReducer,
    legacyTask: LegacyTaskStore.rootReducer,
    Loading: LoadingStore.reducer,
    lisCommand: lisCommandStore.rootReducer,
    employee: Employee.reducer,
    Env: EnvStore.reducer,
    appState: AppState.reducer,
};

// This type can be used as a hint on action creators so that its 'dispatch' and 'getState' params are
// correctly typed to match your store.
export interface AppThunkAction<TAction> {
    (dispatch: (action: TAction) => void, getState: () => ApplicationState): void;
}
